let CCCToIBAN = (ncuenta, cpais) => {
  if (cpais.length !== 2) {
    return ''
  } else {
    let backup = ncuenta
    let aux
    let csiguientes
    let tmp
    ncuenta = ncuenta + (cpais.charCodeAt(0) - 55).toString() + (cpais.charCodeAt(1) - 55).toString() + '00'
    tmp = parseInt(ncuenta.substring(0, 9), 10) % 97
    if (tmp < 10) {
      aux = '0'
    } else {
      aux = ''
    }
    aux = aux + tmp.toString()
    ncuenta = ncuenta.substring(9)
    while (ncuenta !== '') {
      if (parseInt(aux, 10) < 10) {
        csiguientes = 8
      } else {
        csiguientes = 7
      }
      if (ncuenta.length < csiguientes) {
        aux = aux + ncuenta
        ncuenta = ''
      } else {
        aux = aux + ncuenta.substring(0, csiguientes)
        ncuenta = ncuenta.substring(csiguientes)
      }
      tmp = parseInt(aux, 10) % 97
      if (tmp < 10) {
        aux = '0'
      } else {
        aux = ''
      }
      aux = aux + tmp.toString()
    }
    tmp = 98 - parseInt(aux, 10)
    if (tmp < 10) {
      return cpais + '0' + tmp.toString() + backup
    } else {
      return cpais + tmp.toString() + backup
    }
  }
}

const titleAndFavChanger = ({faviconBackup, titleBackup, interval}) => {
  try {
    let favicon = document.querySelector('link[rel~=\'icon\']')
    let title = document.querySelector('title')
    if (interval) {
      clearInterval(interval)
      favicon.href = faviconBackup
      title.innerHTML = titleBackup
      return
    }
    const result = {
      faviconBackup: favicon.href,
      titleBackup: title.innerHTML
    }
    let counter = 1
    result.interval = setInterval(() => {
      if (counter % 2) {
        favicon.href = 'https://cdn.crezu.net/iframe/pic/favicons/fav2.png'
        title.innerHTML = 'Dostań pieniądze!'
      } else {
        favicon.href = 'https://cdn.crezu.net/iframe/pic/favicons/fav1.png'
        title.innerHTML = 'Kontynuuj wniosek'
      }
      counter += 1
    }, 2000)
    return result
  } catch (e) {
    return {}
  }
}

const temporaryRedirectToSiteWithAdsense = (leadId) => {
  const directions = {
    'crezu.vn': {
      lenderLogo: 'https://cdn.crezu.net/offers_data/images/cashspace1.svg',
      redirectUrl: `https://cashspace.vn/reg/?lead_id=${leadId}`,
      header: 'Khoản vay của bạn đã được chấp thuận!',
      subheader: 'Bạn sẽ được chuyển đến trang web của đối tác sau 5 giây.',
      button: 'Tiếp tục',
      timeout: 5000
    },
    'crezu.ph': {
      lenderLogo: 'https://cdn.crezu.net/offers_data/images/cashspace1.svg',
      redirectUrl: `https://cashspace.ph/reg/?lead_id=${leadId}`,
      header: 'Your loan has been approved!',
      subheader: 'You will be redirected to the partner\'s website in 5 seconds.',
      button: 'Continue',
      timeout: 5000
    },
    'andacredito.mx': {
      lenderLogo: 'https://cdn.crezu.net/offers_data/images/crezu.svg',
      redirectUrl: `https://crezu.mx/reg/?lead_id=${leadId}`,
      header: '¡Tu solicitud ha sido aceptada!',
      subheader: 'Serás redirigido al sitio web de la entidad financiera, que ha aceptado la solicitud, en 5 segundos.',
      button: 'Haz clic para continuar',
      timeout: 5000
    },
    'pezetita.mx': {
      lenderLogo: 'https://cdn.crezu.net/offers_data/images/crezu.svg',
      redirectUrl: `https://crezu.mx/reg/?lead_id=${leadId}`,
      header: '¡Tu solicitud ha sido aceptada!',
      subheader: 'Serás redirigido al sitio web de la entidad financiera, que ha aceptado la solicitud, en 5 segundos.',
      button: 'Haz clic para continuar',
      timeout: 5000
    }
  }

  return directions[window.location.hostname]
}

const generateSalaryCycleDates = (salary_cycle) => {
  const today = new Date();
  const result = [];

  switch (salary_cycle) {
    case 'biweekly':
      for (let i = 1; i <= 14; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        const formattedDate = `${date.getDate() < 10 ? '0' : ''}${date.getDate()}/${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}/${date.getFullYear()}`;
        result.push(formattedDate);
      }
      break;

    case 'monthly':
      for (let i = 1; i <= 31; i++) {
        result.push(i);
      }
      break;

    case 'semi_monthly':
      result.push('5 y 20', '10 y 25', '13 y 28', '14 y 29', '15 y 30');
      break;

    case 'weekly':
      for (let i = 1; i <= 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        const formattedDate = `${date.getDate() < 10 ? '0' : ''}${date.getDate()}/${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}/${date.getFullYear()}`;
        result.push(formattedDate);
      }
      break;

    default:
      break;
  }

  return result;
}

export { CCCToIBAN, titleAndFavChanger, temporaryRedirectToSiteWithAdsense, generateSalaryCycleDates }



// WEBPACK FOOTER //
// ./src/helpers.js